import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface IVerifyState {
  isVerified: boolean;
}

const initialState: IVerifyState = {
  isVerified: false,
};

const VerifySlice = createSlice({
  name: "verify",
  initialState,
  reducers: {
    setVerified: (state, action: PayloadAction<boolean>) => {
      state.isVerified = action.payload;
    },
  },
});

export const { setVerified } = VerifySlice.actions;

export default VerifySlice.reducer;